import { Navigate, NavLink, Route, Routes as Switch } from 'react-router-dom';
import { Page, Tab, TabGroup } from '@servicetitan/design-system';
import { Text } from '@servicetitan/anvil2';
import { Tenants } from '../tenants/tenants';
import { Partners } from '../partners/partners';
import { AccountManagementRoutes } from '../../utils/routes';
import { ManageTenant } from '../manage-tenant/manage-tenant';
import { ManagePartner } from '../manage-partner/manage-partner';
import { asParentPath } from '../../../common/utils/as-parent-path';
import { ManagePartition } from '../manage-partition/manage-partition';
import { getNavClickHandler } from '../../../common/utils/get-nav-click-handler';

export const AccountsManagementPage = () => {
    return (
        <Switch>
            <Route path={AccountManagementRoutes.managePartner} element={<ManagePartner />} />
            <Route
                path={asParentPath(AccountManagementRoutes.manageTenant)}
                element={<ManageTenant />}
            />
            <Route path={AccountManagementRoutes.managePartition} element={<ManagePartition />} />
            <Route
                path="*"
                element={
                    <Page
                        header={
                            <Text variant="headline" el="h2" size="large">
                                Accounts Management
                            </Text>
                        }
                    >
                        <TabGroup className="m-b-4">
                            <NavLink to={AccountManagementRoutes.tenants}>
                                {({ isActive }) => (
                                    <Tab active={isActive} onClick={getNavClickHandler(isActive)}>
                                        Tenants
                                    </Tab>
                                )}
                            </NavLink>
                            <NavLink to={AccountManagementRoutes.partners}>
                                {({ isActive }) => (
                                    <Tab active={isActive} onClick={getNavClickHandler(isActive)}>
                                        Partners
                                    </Tab>
                                )}
                            </NavLink>
                        </TabGroup>
                        <Switch>
                            <Route path={AccountManagementRoutes.partners} element={<Partners />} />
                            <Route path={AccountManagementRoutes.tenants} element={<Tenants />} />
                            <Route
                                path="*"
                                element={<Navigate to={AccountManagementRoutes.tenants} replace />}
                            />
                        </Switch>
                    </Page>
                }
            />
        </Switch>
    );
};
